howspace.user = (() => {
    'use strict';

    real.onTierReady(real.TIER_2, () => {
        real.events.on('workspace:user:updated', (notification) => {
            const avatarSizeClasses = [
                'avatar-xs',
                'avatar-sm',
                'avatar-md',
                'avatar-lg',
                'avatar-xl',
            ];

            const updateAvatar = () => {
                $('.avatar-container[data-user-id="' + notification.object.user.id + '"]').each(function () {
                    let avatar = $(this);
                    let avatarClassList = avatar.attr('class').split(/\s+/);
                    // Get the old avatar size class from the list of avatar classes.
                    let oldAvatarSizeClass = avatarClassList.filter(className => {
                        return avatarSizeClasses.includes(className);
                    });

                    const viewable = avatar.hasClass('viewable');

                    howspace.animate(avatar, {opacity: 0}, 350, () => {
                        avatar.removeAttr('style');
                        const newAvatar = $(notification.object.user.avatar.html);
                        const imageWrapper = newAvatar.find('.image-wrapper');

                        // Remove each avatar class from the new avatar.
                        newAvatar.removeClass(avatarSizeClasses);
                        imageWrapper.removeClass(avatarSizeClasses);

                        // Add the old avatar class to the new avatar.
                        newAvatar.addClass(oldAvatarSizeClass);
                        imageWrapper.addClass(oldAvatarSizeClass);

                        if (avatar.closest('.widget-assignment').length > 0 || avatar.closest('.widget-discussion').length > 0) {
                            // Replace the self-center with self-top
                            newAvatar.removeClass('self-center').addClass('self-top');
                        }

                        if (!viewable) {
                            newAvatar.removeClass('viewable cursor-pointer');
                            imageWrapper.removeAttr('tabindex');
                            imageWrapper.removeDataAndAttr('modal');
                        }

                        avatar.replaceWith(newAvatar[0]);
                        howspace.components.init(newAvatar);

                        howspace.animate(newAvatar, {opacity: 1}, 350, () => {
                            newAvatar.css('opacity', '');
                        });
                    });
                });
            };

            if (notification.object.user.avatar) {
                if (notification.object.user.avatar.is_system) {
                    $('.delete-system-avatar-btn').removeClass('d-none');
                }
                updateAvatar();
            }
        });
    });

    real.dom.$body.on('click', '.add-passkey-btn', e => {
        const btn = $(e.currentTarget);
        const modal = btn.closest('.modal');
        const alert = modal.find('.passkeys-alert');
        const lister = modal.find('.passkeys-lister');

        alert.addClass('d-none');
        real.button.loading(btn);

        const successFn = () => {
            howspace.components.lister.reload(lister);
            real.button.reset(btn);
        };

        const errorFn = () => {
            alert.removeClass('d-none');
            real.button.reset(btn);
        };

        howspace.passkeys.createCredential(successFn, errorFn);
    });

    real.dom.$body.on('click', '.delete-passkey-btn', e => {
        const btn = $(e.currentTarget);
        const modal = btn.closest('.modal');
        const alert = modal.find('.passkeys-alert');
        const lister = modal.find('.passkeys-lister');
        const passkeyId = btn.closest('tr').data('id');

        alert.addClass('d-none');

        const successFn = () => {
            howspace.components.lister.reload(lister);
            real.button.reset(btn);
        };

        // The alert is about adding a passkey, so a failed delete is left to the error notification.
        const errorFn = () => {
            real.button.reset(btn);
        };

        howspace.passkeys.deleteCredential(passkeyId, successFn, errorFn);
    });

    const initProfileModal = (modal) => {
        modal = $(modal);
        const userId = modal.data('user-id');

        initUserEditor(modal, userId);

        // Excludes the mandatory-profile-fields modal (real.dom.$body.data('my-profile-card')): it is forced
        // open on load rather than chosen by the user, and its Save handler reloads the page immediately
        // without waiting for the close animation, so the URL restore below would never get a chance to run.
        if (modal.data('is-own-profile-modal') && !real.dom.$body.data('my-profile-card')) {
            const originUrl = window.location.pathname + window.location.search + window.location.hash;
            real.history.replace(real.baseUri + '/manager/my-profile');

            modal.one(howspace.components.modal.MODAL_CLOSED, () => {
                real.history.replace(originUrl);
            });
        }

        modal.find('.btn-success').on('click', e => {
            const btn = $(e.target);
            howspace.user.saveUser(btn, modal, userId, () => {
                howspace.components.modal.close(modal);

                /* This is needed especially for mandatory profile fields that user fills upon login.
                 * In some cases those profile fields are linked to userlists and page access.
                 * Forcing a page refresh would then show the right content to the user right away based on the profile field / dynamic userlist.
                */
                if (real.dom.$body.data('my-profile-card')) {
                    window.location.reload();
                }
            });
        });
    };

    const initTranslationSettingsModal = (modal) => {
        modal = $(modal);
        const userId = modal.data('user-id');

        modal.find('.btn-success').on('click', e => {
            const btn = $(e.target);

            real.button.loading(btn, modal);

            const dataPayload = real.form.getDataPayload(modal);

            real.ajax.json(real.baseUri + '/api/user/' + userId, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    window.location.reload();
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });
    };

    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initImageEditorModal = (modal, modalOpener) => {
        const userId = $(modalOpener).data('user-id');

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_INITIALIZING, e => {
            real.button.loading($(modal).find('.save-image-button'));
        });

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_READY, e => {
            real.button.reset($(modal).find('.save-image-button'));
        });

        modal.addEventListener(howspace.components.imageEditor.IMAGE_EDITOR_SAVE, e => {
            const canvas = e.detail.data;
            const formData = new FormData();
            const token = real.uid();
            formData.append('upload_process_metadata', JSON.stringify({
                token: token
            }));

            // Wait until the image is stored to S3, then save the user.
            const handleStored = (notification) => {
                if (notification.object.uploadedfile?.upload_process_metadata?.token === token) {
                    real.events.off('uploadedfile:stored', handleStored);
                    real.ajax.json(real.baseUri + '/api/user/' + userId, {
                        type: 'POST',
                        data: JSON.stringify({
                            avatar: notification.object.uploadedfile.id
                        }),
                        success: () => {
                            howspace.components.modal.close($('.image-editor-modal:visible'));
                        }
                    });
                }
            };
            real.events.on('uploadedfile:stored', handleStored);

            canvas.toBlob(blob => {
                formData.append('file', blob, userId + '-avatar.png');

                real.ajax(real.baseUri + '/api/uploadedfiles', {
                    type: 'POST',
                    data: formData,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                });
            }, 'image/png');
        });
    };

    const initConfirmLogoutModal = (modal) => {
        modal = $(modal);

        const btn = modal.find('.modal-footer .btn-success');
        const userId = modal.data('user-id');

        btn.on('click', () => {
            real.button.loading(btn, modal);

            const logoutSelf = real.dom.$body.data('user-id') === userId;
            const dataPayload = {
                _action: 'logout'
            };

            real.ajax.json(real.baseUri + '/api/user/' + userId, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: function (response) {
                    if (logoutSelf) {
                        window.location.href = '/sessions/end';
                    } else {
                        // Close confirm modal.
                        real.notification.show(modal.find('.success-notification').html(), 'success');
                        howspace.components.modal.close(modal);
                    }
                }
            });
        });
    };

    const initConfirmLeaveWorkspaceModal = (modal) => {
        modal = $(modal);

        const btn = modal.find('.modal-footer .btn-danger');
        const userId = modal.data('user-id');

        btn.on('click', () => {
            real.button.loading(btn, modal);

            const dataPayload = {
                _action: 'leave_workspace'
            };

            real.ajax.json(real.baseUri + '/api/user/' + userId, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: function () {
                    // This will be handled by the session:logout event.
                }
            });
        });
    };

    const initUserEditor = (parent, userId) => {
        const whatsNewHiddenInput = parent.find('#whats-new-email-delivery-policy-never-hidden-input');
        const whatsNewSelect = parent.find('#whats-new-email-notification-select');
        const personalInformationCard = parent.find('#card-personal-information');

        real.autosize.init(personalInformationCard);

        // When enable/disable what's new email notifications toggle -> juggle the name attribute of
        // the select and the hidden input to decide which one will be included in the data payload.
        parent.find('#whats-new-email-notifications-toggle-button').on('change', e => {
            if (e.target.checked) {
                whatsNewHiddenInput.removeAttr('name');
                whatsNewSelect.attr('name', 'whats_new_email_delivery_policy');
            } else {
                whatsNewSelect.removeAttr('name');
                whatsNewHiddenInput.attr('name', 'whats_new_email_delivery_policy');
            }
        });

        const approvalCheckbox = parent.find('#user-consent-approval-checkbox');
        const showChatCheckbox = parent.find('#user-consent-show-chat-checkbox');
        approvalCheckbox.dataAndAttr('was-checked', approvalCheckbox.prop('checked'));
        showChatCheckbox.dataAndAttr('was-checked', showChatCheckbox.prop('checked'));

        approvalCheckbox.on('change', function () {
            if (approvalCheckbox.prop('checked')) {
                showChatCheckbox.prop('disabled', false);
                showChatCheckbox.closest('.howspace-form-label').removeClass('disabled');
            } else {
                showChatCheckbox.prop('disabled', true).prop('checked', false);
                showChatCheckbox.closest('.howspace-form-label').addClass('disabled');
            }
        });

        const checkProfileFieldCheckboxes = (profileField) => {
            if (
                profileField.find('input[type="checkbox"]:checked').length >= profileField.data('max-select-count') &&
                profileField.data('max-select-count') > 1
            ) {
                profileField.find('input[type="checkbox"]:not(:checked)')
                    .prop('disabled', true)
                    .closest('.howspace-form-label')
                    .addClass('disabled')
                ;
            } else {
                profileField.find('input[type="checkbox"]:not(:checked)')
                    .prop('disabled', false)
                    .closest('.howspace-form-label')
                    .removeClass('disabled')
                ;
            }
        };

        const checkSaveProfileBtn = () => {
            let saveDisabled = false;

            const handleNotValid = (profileField) => {
                const tooltip = profileField.find('.mandatory-tooltip');
                if (tooltip.length > 0) {
                    howspace.components.toolTip.enable(tooltip);
                }
                profileField.find('.mandatory-icon').removeClass('d-none');
                saveDisabled = true;
            };

            const handleValid = (profileField) => {
                const tooltip = profileField.find('.mandatory-tooltip');
                if (tooltip.length > 0) {
                    howspace.components.toolTip.disable(tooltip);
                }
                profileField.find('.mandatory-icon').addClass('d-none');
            };

            personalInformationCard.find('.profile-field[data-is-mandatory="1"]').each(function (i, profileField) {
                profileField = $(profileField);
                const type = profileField.data('profile-field-type');
                if (type === 'text') {
                    if (profileField.find('.howspace-form-input').val().trim() === '') {
                        handleNotValid(profileField);
                    } else {
                        handleValid(profileField);
                    }
                } else if (type === 'multiple_choice') {
                    let isGood = true;
                    if (profileField.find('select').length > 0) {
                        if (profileField.find('select').val() === '') {
                            isGood = false;
                        }
                    } else {
                        if (profileField.find('input[type="checkbox"]:checked').length < profileField.data('min-select-count')) {
                            isGood = false;
                        }
                    }
                    if (!isGood) {
                        handleNotValid(profileField);
                    } else {
                        handleValid(profileField);
                    }
                } else if (type === 'organization') {
                    if (!profileField.find('select').val()) {
                        handleNotValid(profileField);
                    } else {
                        handleValid(profileField);
                    }
                } else {
                    throw new Error('Unknown profile field type "' + type + '"');
                }
            });

            if (saveDisabled && personalInformationCard.find('#card-personal-information-content').is('.collapsed')) {
                // Open personal information card.
                personalInformationCard.find('.card-title').trigger('click');
            }

            if (
                parent.find('#card-roles').length > 0 &&
                parent.find('#card-roles input[name="roles[]"]:checked').length === 0
            ) {
                // Roles card exists and no roles are checked.
                saveDisabled = true;
            }

            $('.save-profile-btn').prop('disabled', saveDisabled);
        };

        personalInformationCard.on(
            'change',
            '.profile-field[data-profile-field-type="multiple_choice"] input[type="checkbox"]',
            function () {
                const checkbox = $(this);
                const profileField = checkbox.closest('.profile-field');
                if (profileField.data('max-select-count') === 1) {
                    profileField.find('input[type="checkbox"]').not(checkbox).prop('checked', false);
                }
                checkProfileFieldCheckboxes(profileField);
                checkSaveProfileBtn();
            }
        );

        personalInformationCard.on(
            'change',
            '.profile-field[data-profile-field-type="multiple_choice"] select',
            checkSaveProfileBtn
        );
        personalInformationCard.on(
            'change',
            '.profile-field[data-profile-field-type="organization"] select',
            checkSaveProfileBtn
        );
        personalInformationCard.on(
            'input',
            '.profile-field[data-profile-field-type="text"] .howspace-form-input',
            checkSaveProfileBtn
        );

        personalInformationCard.on(howspace.components.collapse.EXPANDING, (e) => {
            requestAnimationFrame(function () {
                real.autosize.update($(e.target));
            });
        });

        personalInformationCard.find('.profile-field[data-profile-field-type="multiple_choice"]').each(function () {
            checkProfileFieldCheckboxes($(this).closest('.profile-field'));
        });

        checkSaveProfileBtn();
    };

    const saveUser = (button, parent, userId, readyFn) => {
        const approvalCheckbox = parent.find('#user-consent-approval-checkbox');
        const showChatCheckbox = parent.find('#user-consent-show-chat-checkbox');

        real.button.loading(button, parent);

        if (
            approvalCheckbox.prop('checked') !== approvalCheckbox.data('was-checked') ||
            showChatCheckbox.prop('checked') !== showChatCheckbox.data('was-checked')
        ) {
            // Consent changed, save consent to system user first.
            saveSystemUser(button, parent, userId, readyFn);
        } else {
            // Consent not changed, continue straight to save user.
            saveWorkspaceUser(button, parent, userId, readyFn);
        }
    };

    const saveSystemUser = function (button, parent, userId, readyFn) {
        const approvalCheckbox = parent.find('#user-consent-approval-checkbox');
        const showChatCheckbox = parent.find('#user-consent-show-chat-checkbox');

        real.ajax.json(real.baseUri + '/api/systemuser/consent', {
            type: 'POST',
            data: JSON.stringify({
                approval: approvalCheckbox.prop('checked'),
                show_chat: showChatCheckbox.prop('checked')
            }),
            success: function () {
                // Consent saved to system user, continue to save the user.
                saveWorkspaceUser(button, parent, userId, readyFn);
            },
            error: function (response) {
                real.button.reset(button, parent);
            }
        });
    };

    // Account Manager and Admin Manager reach a workspace user through the workspace they are looking at. On their
    // pages without a workspace, such as the account user list, the plain route is the right one again.
    const getUserApiUrl = userId => {
        const workspaceId = real.dom.$body.data('workspace-id');
        const inManager = howspace.accountManager !== undefined || howspace.adminManager !== undefined;
        if (inManager && workspaceId) {
            return '/api/workspace/' + workspaceId + '/user/' + userId;
        }
        return '/api/user/' + userId;
    };

    const saveWorkspaceUser = (button, parent, userId, readyFn) => {
        const dataPayload = real.form.getDataPayload(parent);

        // User profile field values have to be manually added to the data payload.
        const profileFields = $('#card-personal-information .profile-field');

        if (profileFields.length > 0) {
            dataPayload.user_profile_field_values = [];
            dataPayload.user_profile_field_text_values = [];
            profileFields.each(function (i, profileField) {
                profileField = $(profileField);

                const obj = {
                    user_profile_field: profileField.data('profile-field-id')
                };

                switch (profileField.data('profile-field-type')) {
                    case 'text':
                        obj.value = profileField.find('.howspace-form-input').val().trim();
                        dataPayload.user_profile_field_text_values.push(obj);
                        break;

                    case 'multiple_choice':
                        obj.value = [];
                        profileField.find('input[type="checkbox"]:checked').each(function () {
                            obj.value.push(parseInt($(this).val()));
                        });
                        profileField.find('select').each(function () {
                            if ($(this).val() !== '') {
                                obj.value.push(parseInt($(this).val()));
                            }
                        });
                        dataPayload.user_profile_field_values.push(obj);
                        break;

                    case 'organization':
                        obj.value = profileField.find('select').val();
                        dataPayload.user_profile_field_values.push(obj);
                        break;

                    default:
                        throw new Error(
                            'Unknown profile field type "' + profileField.data('profile-field-type') + '"'
                        );
                }
            });
        }

        real.ajax.json(real.baseUri + getUserApiUrl(userId), {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                real.button.reset(button, parent);
                if (typeof readyFn === 'function') {
                    readyFn();
                }
            },
            error: () => {
                real.button.reset(button, parent);
            }
        });
    };

    const deleteAvatar = (btn, userId) => {
        const dataPayload = {
            avatar: null
        };

        $('.delete-user-avatar-btn').addClass('d-none');
        $('.set-system-avatar-btn').addClass('d-none');
        $('.delete-system-avatar-btn').addClass('d-none');

        real.ajax.json(real.baseUri + '/api/user/' + userId, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            complete: () => {
                real.button.reset(btn, btn.closest('.modal'));
            }
        });
    };

    real.dom.$body.on('click', '.delete-user-avatar-btn', (e) => {
        const btn = $(e.currentTarget);
        const userId = btn.data('user-id');

        real.button.loading(btn, btn.closest('.modal'));

        deleteAvatar(btn, userId);
    });

    const initDeleteConfirmationAccessibility = (modal, modalOpener) => {
        if (modal instanceof jQuery) {
            modal = modal[0];
        }

        const opener = $(modalOpener);
        const dropdown = opener.closest('.dropdown');
        const returnFocus = dropdown.length ? dropdown.find('[data-toggle="dropdown"]').first()[0] : opener[0];

        // MODAL_CLOSED fires before the native dialog closes, while the background is still inert.
        modal.addEventListener('close', () => {
            if (returnFocus?.isConnected && $(returnFocus).is(':visible')
                && !returnFocus.matches(':disabled, [aria-disabled="true"]')
                && !document.querySelector('dialog[open]')) {
                returnFocus.focus();
            }
        }, {once: true});

        modal.querySelector('.modal-footer [data-close-modal="true"]')?.focus();
    };

    const initConfirmDeleteModal = (modal, modalOpener) => {
        initDeleteConfirmationAccessibility(modal, modalOpener);
        modal = $(modal);
        const userId = modal.data('user-id');
        const userRow = $('.users-table tr.user-row[data-user-id="' + userId + '"]');
        const userCard = $('.user-card[data-user-id="' + userId + '"]');

        const deleteBtn = modal.find('.modal-footer .delete-user-btn');
        deleteBtn.on('click', () => {
            real.button.loading(deleteBtn, modal);

            real.ajax.json(real.baseUri + '/api/user/' + userId, {
                type: 'DELETE',
                error: () => {
                    real.button.reset(deleteBtn, modal);
                },
                success: () => {
                    // The button stays busy until the session:logout event takes the admin out of the workspace.
                    if (modal.data('self-delete')) {
                        return;
                    }

                    userRow.remove();
                    userCard.remove();

                    const activeTabCountElement = $('#tab-users-active').find('.howspace-lister-items-count');
                    const activeCount = parseInt(activeTabCountElement.text().replace('(', '').replace(')', '')) - 1;
                    activeTabCountElement.text('(' + activeCount + ')');
                    howspace.components.lister.reload($('#users-deleted-lister'));

                    if (activeCount === 0) {
                        howspace.components.lister.reload($('#users-active-lister'));
                    }
                    howspace.components.modal.close(modal[0]);
                }
            });

        });
    };

    const initConfirmRemoveSuppressionModal = (modal) => {
        modal = $(modal);
        const btn = modal.find('.save-btn');
        // Admin Manager reaches an account user through their customer, a route no body data attribute spells out,
        // so a modal may name its own endpoint. The attribute sits on the button, not the dialog, because
        // data-api-url on the dialog is what makes the manager apps post the form generically.
        const apiUrl = btn.data('api-url') || getUserApiUrl(modal.data('user-id'));

        btn.on('click', () => {
            real.button.loading(btn, modal);

            const dataPayload = {
                _action: 'unsuppress'
            };

            real.ajax.json(real.baseUri + apiUrl, {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: function () {
                    howspace.components.modal.close(modal);
                    real.notification.show(howspace.translate('user_unsuppression_completed'), 'success');
                    // The delivery error is gone now, so the rows that still show it are out of date. Account
                    // Manager and Admin Manager name their user listers users-lister, the Workspace Manager user
                    // page names its own two active-lister and deleted-lister.
                    $('.users-lister, .active-lister, .deleted-lister')
                        .each((index, lister) => howspace.components.lister.reload($(lister)));
                },
                error: function () {
                    real.button.reset(btn, modal);
                    real.notification.show(howspace.translate('user_unsuppression_failed'), 'danger');
                }
            });
        });
    };

    const initConfirmSetSystemAvatarModal = modal => {
        modal = $(modal);

        modal.find('.btn-success').on('click', () => {
            real.ajax.json(real.baseUri + '/manager/my-profile/system-avatar', {
                type: 'POST',
                data: JSON.stringify({workspace: real.dom.$body.data('workspace-id')}),
                success: () => {
                    $('.delete-user-avatar-btn').addClass('d-none');
                    $('.set-system-avatar-btn').addClass('d-none');
                    $('.delete-system-avatar-btn').removeClass('d-none');
                },
                complete: () => {
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    const initConfirmDeleteSystemAvatarModal = modal => {
        modal = $(modal);

        modal.find('.btn-success').on('click', () => {
            real.ajax.json(real.baseUri + '/manager/my-profile/system-avatar', {
                type: 'DELETE',
                data: JSON.stringify({workspace: real.dom.$body.data('workspace-id')}),
                success: () => {
                    $('.delete-user-avatar-btn').addClass('d-none');
                    $('.set-system-avatar-btn').addClass('d-none');
                    $('.delete-system-avatar-btn').addClass('d-none');
                },
                complete: () => {
                    howspace.components.modal.close(modal);
                }
            });
        });
    };

    const initScheduleUserDeletionModal = (modal) => {
        modal = $(modal);

        modal.find('.modal-footer .save-btn').on('click', (e) => {
            const btn = $(e.target);
            saveUser(btn, modal, modal.data('user-id'));
            howspace.components.modal.close(modal);
        });
    };

    const initConfirmAddAdminRoleModal = (modal) => {
        modal = $(modal);
        const userId = modal.data('user-id');

        modal.find('.modal-footer .add-user-admin-role-btn').on('click', (e) => {
            const btn = $(e.currentTarget);
            const dataPayload = {
                roles: [
                    btn.data('admin-role-id'),
                    btn.data('participant-role-id')
                ]
            };

            real.ajax.json(real.baseUri + getUserApiUrl(userId), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                    real.notification.show(modal.find('.success-notification').html(), 'success');
                }
            });
        });
    };

    const initConfirmRemoveAdminRoleModal = (modal) => {
        modal = $(modal);
        const userId = modal.data('user-id');

        modal.find('.modal-footer .remove-user-admin-role-btn').on('click', (e) => {
            const btn = $(e.currentTarget);
            const dataPayload = {
                roles: [
                    btn.data('participant-role-id')
                ]
            };

            real.ajax.json(real.baseUri + getUserApiUrl(userId), {
                type: 'POST',
                data: JSON.stringify(dataPayload),
                success: () => {
                    howspace.components.modal.close(modal);
                    real.notification.show(modal.find('.success-notification').html(), 'success');
                }
            });
        });
    };

    return {
        initProfileModal: initProfileModal,
        initTranslationSettingsModal: initTranslationSettingsModal,
        initConfirmLogoutModal: initConfirmLogoutModal,
        initConfirmLeaveWorkspaceModal: initConfirmLeaveWorkspaceModal,
        initUserEditor: initUserEditor,
        saveUser: saveUser,
        initImageEditorModal: initImageEditorModal,
        initConfirmDeleteModal: initConfirmDeleteModal,
        initDeleteConfirmationAccessibility: initDeleteConfirmationAccessibility,
        initConfirmRemoveSuppressionModal: initConfirmRemoveSuppressionModal,
        initConfirmSetSystemAvatarModal: initConfirmSetSystemAvatarModal,
        initConfirmDeleteSystemAvatarModal: initConfirmDeleteSystemAvatarModal,
        initScheduleUserDeletionModal: initScheduleUserDeletionModal,
        initConfirmAddAdminRoleModal: initConfirmAddAdminRoleModal,
        initConfirmRemoveAdminRoleModal: initConfirmRemoveAdminRoleModal,
    };

})();
